export enum EDeliveryStatus {
  NEW = "N",
  IN_PROGRESS = "I",
  COMPLETE = "C",
}
